/**
 * True only when running the local dev server.
 *
 * Two independent gates, both of which must hold:
 *
 * 1. `__DEV__` — a compile-time global injected by rsbuild
 *    (`NODE_ENV !== 'production'`; see shared/rsbuild.config.ts). Every deployed
 *    build goes through `plz build`, which pins `NODE_ENV=production`, so
 *    `__DEV__` is baked in as false on alpha, PR-preview, production, and
 *    rex-dev-env (which serves a production build). It is only true under
 *    `rsbuild dev` (the local dev server).
 * 2. A loopback hostname — belt-and-braces so support-only UI can never be
 *    exposed on a real host even if the build tooling ever stopped pinning
 *    `NODE_ENV=production`.
 *
 * Guarded with `typeof __DEV__ !== 'undefined'` / `typeof window !== 'undefined'`
 * so a bare reference never throws when the rsbuild global or `window` is absent
 * (e.g. under test / SSR).
 */
const LOOPBACK_HOSTS = ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'];

export function isLocalDev() {
  if (typeof __DEV__ === 'undefined' || !__DEV__) {
    return false;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  return LOOPBACK_HOSTS.includes(window.location?.hostname);
}
